import { timeOptions } from 'constants';
import { create } from 'zustand';
export const useOnboardingStore = create((set, get) => ({
  selectedDateFilterOnboarding: timeOptions.find(opt=>opt.value===2),
  setSelectedDateFilterOnboarding: (selectedDateFilterOnboarding = {}) => set(() => ({ selectedDateFilterOnboarding })),
}));

